<template>
  <div
    class="flex h-full min-h-0 w-full flex-col overflow-hidden bg-n-surface-1"
  >
    <div
      class="mx-auto flex h-full min-h-0 w-full max-w-7xl flex-col px-4 py-4"
    >
      <router-view />
    </div>
  </div>
</template>
